<!--  Use our app Section -->
@if(!router.url.includes(CANCEL) && !router.url.includes(SUCCESS) && !router.url.includes(ADVOCATES) && !router.url.includes(EMPLOYERS) && !router.url.includes('professional-book-appointment')){
  <section class="container-fluid useourapp-section">
    <div class="container">
      <app-imagebox-one [showAppBtns]="true" [imageStyle]="'max-height:518px;'"
        [heading]="('FOOTER.APPINFOTITLE' | translate)"
        [image]="sharedService.imagesUrl+'app-section-img.webp'"></app-imagebox-one>
    </div>
  </section>
}
<!--  Use our app Section End -->

<footer class="container-fluid">
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <div class="row">
          <div class="col-md-12">
            <div class="footer-desc-logo" style="margin-bottom: 20px">
              <img src="{{sharedService.imagesUrl}}footer-logo.svg" />
            </div>
            <div class="footer-desc-section">
              <div class="footer-desc-section-text">
                {{ 'FOOTER.DESCRIPTION' | translate: { tenant: 'WOW' } }}
              </div>
              <div class="footer-desc-section-icons">
                <div class="footer-desc-section-icon">
                  <img src="{{sharedService.imagesUrl}}icons/facebook.svg" />
                </div>
                <div class="footer-desc-section-icon">
                  <img src="{{sharedService.imagesUrl}}icons/linkedin.svg" />

                </div>
                <div class="footer-desc-section-icon">
                  <img src="{{sharedService.imagesUrl}}icons/twitter.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <!-- Footer Menus -->
        <div class="row footer-menu-section">
          <div class="col-md-4">
            <div class="footer-menus">
              <div class="footer-menu-item">
                <div class="footer-menu-item-title">{{ 'MENU.MEMBERSHIP' | translate }}</div>
                <a class="footer-menu-item-menu" [routerLink]="routes.plusMembership">
                  {{ 'MENU.EVERYDAY_CARE' | translate: { tenant: 'WOW' } }}
                </a>
                <a class="footer-menu-item-menu" [routerLink]="routes.healthSharing">
                  {{ 'MENU.HEALTH_SHARE_FOR_LARGE' | translate }}
                </a>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>
              </div>
              <div class="footer-menu-item">
                <div class="footer-menu-item-title">{{ 'MENU.FOR_EMPLOYERS' | translate }}</div>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>
              </div>
              <div class="footer-menu-item">
                <div class="footer-menu-item-title">{{ 'MENU.FOR_BROKERS' | translate }}</div>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="footer-menus">
              <div class="footer-menu-item">
                <div class="footer-menu-item-title" >{{ 'MENU.FOR_MEMBERS' | translate }}</div>
                <a class="footer-menu-item-menu" [routerLink]="routes.officeVisit">{{ 'MENU.OFFICE_VISITS' | translate }}</a>
                <a class="footer-menu-item-menu" [routerLink]="routes.virtualUrgentCare">
                  {{ 'MENU.VIRTUAL_URGENT_CARE' | translate }}
                </a>
                <a class="footer-menu-item-menu" [routerLink]="routes.mentalHealth">{{ 'MENU.MENTAL_HEALTH' | translate }}</a>
                <a class="footer-menu-item-menu" [routerLink]="routes.pharmacy">{{ 'MENU.PHARMACY' | translate }}</a>
                <a class="footer-menu-item-menu" [routerLink]="routes.visionService">{{ 'MENU.VISION_CARE' | translate }}</a>
                <a class="footer-menu-item-menu" [routerLink]="routes.dental">{{ 'MENU.DENTAL_CARE' | translate }}</a>
                <a class="footer-menu-item-menu" [routerLink]="routes.imaging">{{ 'MENU.IMAGING' | translate }}</a>
                <a class="footer-menu-item-menu" [routerLink]="routes.labTest">{{ 'MENU.LAB_TESTS' | translate }}</a>
                <a class="footer-menu-item-menu" [routerLink]="routes.surgical">
                  {{ 'MENU.PROCEDURES_SURGERIES' | translate }}
                </a>
                <a class="footer-menu-item-menu" [routerLink]="routes.healthShare">{{ 'MENU.HEALTH_SHARE' | translate }}</a>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="footer-menus">
              <div class="footer-menu-item">
                <div class="footer-menu-item-title">{{ 'MENU.ABOUT_US' | translate }}</div>
                <a class="footer-menu-item-menu" [routerLink]="routes.aboutUs">{{ 'MENU.ABOUT_US' | translate }}</a>
                <a class="footer-menu-item-menu" [routerLink]="routes.contactUs">{{ 'MENU.CONTACT_US' | translate }}</a>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>
              </div>
              <div class="footer-menu-item">
                <div class="footer-menu-item-title">{{ 'MENU.RESOURCES' | translate }}</div>
                <a class="footer-menu-item-menu" [routerLink]="routes.wowVideo">{{ 'MENU.VIDEOS' | translate }}</a>
                <a class="footer-menu-item-menu" [routerLink]="routes.blogs">{{ 'MENU.BLOGS' | translate }}</a>
                <a class="footer-menu-item-menu" [routerLink]="routes.faqs">{{ 'MENU.FAQS' | translate }}</a>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="footer-menus">
              <div class="footer-menu-item">
                <div class="footer-menu-item-title">{{ 'FOOTER.SIGNUP_AS' | translate }}</div>
                <div class="footer-menu-item-menu">{{ 'FOOTER.EMPLOYERS' | translate }}</div>
                <div class="footer-menu-item-menu">{{ 'FOOTER.PROVIDER' | translate }}</div>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Footer Menus End -->
      </div>
    </div>
    <div class="row copyright-section">
      <div class="col-md-3 languagesection">
        <div class="row">
          <div class="col-md-6 col-6">
            
            <select class="form-control" (change)="setLanguage($event)">
              <option [selected]="sharedService.currentLanguage === 'en' ? true : null" value="en">English</option>
              <option [selected]="sharedService.currentLanguage === 'fr' ? true : null" value="fr">French</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-9 copyrightdiv">
        <div class="copyrightdiv-left">
          <div class="copyrightdiv-text">
            Copyright © 2023 WoW Health Solutions. All Rights Reserved
          </div>
          <!-- <div class="termprivacy"> -->
          <a (click)="openTermUseModal()">Terms of use</a>
          <a (click)="openPrivacyPoliciesModal()">Privacy policy</a>
          <!-- </div> -->
        </div>
        <div class="copyrightdiv-logo">
          <!-- Image will moved to assets later -->
          <img [src]="sharedService.imagesUrl+'hippa-compliance.svg'" width="156" height="75" alt="" />
          <!-- Image will moved to assets later -->
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 30px">
      <div class="col-md-10">&nbsp;</div>
      <div class="col-md-2"></div>
    </div>
  </div>
</footer>

<!-- <app-terms-of-use-modal></app-terms-of-use-modal>
<app-privacy-policy-modal></app-privacy-policy-modal> -->
